export default __webpack_public_path__ + "static/media/foot-right-front.9766b472.png";